export const initializeDeleteModalButton = (): void => {
  $(document).on("click", ".toggle-delete-modal", (event) => {
    event.preventDefault();

    const deleteButton = event.currentTarget;
    const dataType = deleteButton.dataset.type;
    const dataHref = deleteButton.dataset.href;

    $(`.delete-${dataType}`).attr("href", dataHref);
  });

  $(document).on("click", ".toggle-approve-modal", (event) => {
    event.preventDefault();

    const approveButton = event.currentTarget;
    const dataType = approveButton.dataset.type;
    const dataHref = approveButton.dataset.href;

    $(`.approve-${dataType}`).attr("href", dataHref);
  });

  $(document).on("click", ".toggle-reject-modal", (event) => {
    event.preventDefault();

    const rejectButton = event.currentTarget;
    const dataType = rejectButton.dataset.type;
    const dataHref = rejectButton.dataset.href;

    $(`.reject-${dataType}`).attr("href", dataHref);
  });
};

export const cleanUpDeleteModalButton = (): void => {
  $(document).prop("onclick", null).off("click");
};
